import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import cookies from '../../utils/cookies'
import styles from './styles'
import LiveNow from '../LiveNow'
import ScrollableList from '../ScrollableList'
import PlayerApi from '../../utils/playerApi'
import Skeleton from '../Skeleton/Skeleton'
import { setChannels } from '../../actions'
import {
  STV_COOKIES,
} from '../../constants'

const LiveCardOverlay = ({ groupToken, renderCTVBanner }) => {
  const [error, setError] = useState(false)
  const channels = useSelector(state => state.liveChannels.data)
  const { STV_AUTH_REQUIRED } = STV_COOKIES
  const playerApi = PlayerApi()
  const dispatch = useDispatch()
  const opts = {
    query: { groupToken },
    dispatch,
    sendAuthHeader: cookies.get(STV_AUTH_REQUIRED) === 'true',
  }

  useEffect(() => {
    if (channels) {
      setError(false)
      return
    }

    async function updateSchedule() {
      try {
        // Only fetch if we don't have data already
        const response = await playerApi({
          ...opts,
          path: '/channels',
        })
        dispatch(setChannels(response))
        setError(false)
      } catch (err) {
        setError(true)
        dispatch(setChannels([]))
      }
    }

    updateSchedule()
  }, [])

  return (
    <>
      <div className="live-tv-container" style={renderCTVBanner ? { top: '90px' } : {}}>
        <div className="live-tv-content">
          <ScrollableList className="overlay" isOverlay>
            {!error && channels
              ? <LiveNow isOverlay channels={channels} />
              : (
                <React.Fragment>
                  <Skeleton />
                  <Skeleton />
                </React.Fragment>
              )}
          </ScrollableList>
        </div>
        <style jsx>{styles}</style>
      </div>
    </>
  )
}

LiveCardOverlay.propTypes = {
  groupToken: PropTypes.string.isRequired,
  renderCTVBanner: PropTypes.bool,
}

LiveCardOverlay.defaultProps = {
  renderCTVBanner: false,
}

export default LiveCardOverlay
